import {
  AIRPORT_PICKUP_DETAILS_SUCCESS,
  DOCTOR_PROVIDED_OPINION_SUCCESS,
  FETCH_COUNTRY_MASTER_SUCCESS,
  FETCH_DASHBOARD_COUNT_SUCCESS,
  FETCH_DASHBOARD_SUMMARY_SUCCESS,
  FETCH_DOCTOR_REMINDER_SUCCESS,
  FETCH_EMBASSY_MASTER_SUCCESS,
  FETCH_EXISTING_PATIENTS_SUCCESS,
  FETCH_GENERATE_TEMPLATE_SUCCESS,
  FETCH_HEALTHCONCERN_SUCCESS,
  FETCH_HOSPITALS_SUCCESS,
  FETCH_PASSPORT_DETAILS_SUCCESS,
  FETCH_PATIENT_DETAILS_SUCCESS,
  FETCH_RECOMMENDED_DOCTORS_SUCCESS,
  FETCH_TEMPLATE_DATA_FIELDS_SUCCESS,
  FETCH_VIL_TEMPLATE_SUCCESS,
  FETCH_VIL_UPDATE_SUCCESS,
  PROVIDE_OPINION_SUCCESS,
  RESET_DOCTOR_REMINDER,
} from "./actions";

const initialState = {
  loading: false,
  errorResponse: false,
  dashboardCount: [],
  dashboardSummary: [],
  patientDetails: [],
  recommendedDoctors: [],
  passportLabel: false,
  passportDetails: false,
  isProvidedOpinion: false,
  providedOpinion: [],
  airportPickUpDetails: [],
  doctorProvidedOpinion: [],
  templateDataFields: [],
  generateTemplateData: [],
  embassyMaster: [],
  vilTemplates: [],
  vilUpdateResponse: "",
  countryData: [],
  hospitalData: [],
  healthConcernData: [],
  existingPatientsResponse: false,
  doctorReminderResponse: null,
};

const ipsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DASHBOARD_COUNT_SUCCESS:
      return {
        ...state,
        dashboardCount: action.payload,
        errorResponse: false,
      };
    case FETCH_DASHBOARD_SUMMARY_SUCCESS:
      return {
        ...state,
        dashboardSummary: action.payload,
        errorResponse: false,
      };
    case FETCH_PATIENT_DETAILS_SUCCESS:
      return {
        ...state,
        patientDetails: action.payload,
        errorResponse: false,
      };
    case FETCH_RECOMMENDED_DOCTORS_SUCCESS:
      return {
        ...state,
        recommendedDoctors: action.payload,
        errorResponse: false,
      };
    case FETCH_PASSPORT_DETAILS_SUCCESS:
      return {
        ...state,
        passportDetails: action.payload,
        passportLabel: action.passportLabel,
        errorResponse: false,
      };
    case PROVIDE_OPINION_SUCCESS:
      return {
        ...state,
        isProvidedOpinion: true,
        providedOpinion: action.payload,
        errorResponse: false,
      };
    case AIRPORT_PICKUP_DETAILS_SUCCESS:
      return {
        ...state,
        airportPickUpDetails: action.payload,
        errorResponse: false,
      };
    case DOCTOR_PROVIDED_OPINION_SUCCESS:
      return {
        ...state,
        doctorProvidedOpinion: action.payload,
        errorResponse: false,
      };
    case FETCH_TEMPLATE_DATA_FIELDS_SUCCESS:
      return {
        ...state,
        templateDataFields: action.payload,
        errorResponse: false,
      };
    case FETCH_GENERATE_TEMPLATE_SUCCESS:
      return {
        ...state,
        generateTemplateData: action.payload,
        errorResponse: false,
      };
    case FETCH_EMBASSY_MASTER_SUCCESS:
      return {
        ...state,
        embassyMaster: action.payload,
        errorResponse: false,
      };
    case FETCH_VIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        vilTemplates: action.payload,
        errorResponse: false,
      };
    case FETCH_VIL_UPDATE_SUCCESS:
      return {
        ...state,
        vilUpdateResponse: action.payload,
        errorResponse: false,
      };
    case FETCH_COUNTRY_MASTER_SUCCESS:
      return {
        ...state,
        countryData: action.payload.data,
        errorResponse: false,
      };
    case FETCH_HEALTHCONCERN_SUCCESS:
      return {
        ...state,
        healthConcernData: action.payload,
        errorResponse: false,
      };
    case FETCH_HOSPITALS_SUCCESS:
      return {
        ...state,
        hospitalData: action.payload,
        errorResponse: false,
      };
    case FETCH_EXISTING_PATIENTS_SUCCESS:
      return {
        ...state,
        existingPatientsResponse: action.payload,
        errorResponse: false,
      };
    case FETCH_DOCTOR_REMINDER_SUCCESS:
      return {
        ...state,
        doctorReminderResponse: action.payload,
        errorResponse: false,
      };
    case RESET_DOCTOR_REMINDER:
      return {
        ...state,
        doctorReminderResponse: null,
      };
    default:
      return state;
  }
};

export default ipsReducer;
